// src/services/templateService.ts
import { ChatbotType } from '@/models/Chatbot';

// Dream builder templates
import simpleChatbotConfig from '@/utils/flow_templates/chatflows/simple-chatbot.json';
import qaChatbotConfig from '@/utils/flow_templates/chatflows/qa-chatbot.json';
import figmaDev from '@/utils/flow_templates/chatflows/figma-dev.json';
import notionChatbotConfig from '@/utils/flow_templates/chatflows//notion-chatbot.json';
import agent from '@/utils/flow_templates/chatflows/agent.json';
import audioContentCreatorConfig from '@/utils/flow_templates/chatflows/audio-content-creator.json';
import audioTranscriptionConfig from '@/utils/flow_templates/chatflows/audio-transcription.json';
import imageGenerationConfig from '@/utils/flow_templates/chatflows/image-generation.json';

// Workflow templates
import documentIndexingConfig from '@/utils/flow_templates/workflows/document-indexing.json';
import knowledgeBaseUpdaterConfig from '@/utils/flow_templates/workflows/knowledge-base-updater.json';


export interface TemplateConfig {
  id: string;
  name: string;
  description: string;
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  configuration: Record<string, any>;
}

const templates: TemplateConfig[] = [
  { ...simpleChatbotConfig },
  { ...qaChatbotConfig },
  { ...imageGenerationConfig },
  { ...audioContentCreatorConfig },
  { ...audioTranscriptionConfig },
  { ...figmaDev},
  { ...notionChatbotConfig},
  { ...agent},

  { ...documentIndexingConfig},
  { ...knowledgeBaseUpdaterConfig}
];

export const getTemplateConfig = (templateId: string, type: ChatbotType): TemplateConfig | undefined => {
  return templates.find(template => template.id === templateId && template.type === type);
};

export const getAllTemplates = (type: ChatbotType): TemplateConfig[] => {
  return templates.filter(template => template.type === type);
};